import Product from './Models/Product'

Vue.prototype.$models.$product = new Vue(Product)

Vue.component('products-table', () => import(/* webpackChunkName: "products-table" */ '@modulesPages/Product/Resources/assets/js/Tables/ProductsTable'))

Vue.component('products-form', () => import(/* webpackChunkName: "products-form" */ '@modulesPages/Product/Resources/assets/js/Forms/Products/ProductsForm'))

Vue.component('products-card', () => import(/* webpackChunkName: "products-card" */ '@modulesPages/Product/Resources/assets/js/Cards/ProductsCard'))

Vue.component('new-products-section', () => import(/* webpackChunkName: "new-products-section" */ '@modulesPages/Product/Resources/assets/js/Sections/NewProductsSection'))



Vue.component('products-form2', () => import(/* webpackChunkName: "products-form2" */ '@modulesPages/Product/Resources/assets/js/Forms/Products/ProductsForm2'))


app.$Util.formattedClassName = {
    ...app.$Util.formattedClassName,
    ...{
        'Modules\\Product\\Entities\\Product': 'Producto',
    }   
}

app.$Util.tableNameByClassName = {
    ...app.$Util.tableNameByClassName,
    ...{
        'Modules\\Product\\Entities\\Product': 'products',
    }   
}

app.$Util.classNameByTableName = {
    ...app.$Util.classNameByTableName,
    ...{
        'products': 'Modules\\Product\\Entities\\Product',
    }   
}
